import { createSelector } from "@reduxjs/toolkit";

import type { DesignerNodeData } from "../../schemas/index.ts";
import { nodeDesignsStateSelector } from "../managed/index.ts";
import {
  findParentlessNodeId,
  type GetDesignerNodeDataById,
  getDesignerNodeDataByIdCreate,
} from "../querying/index.ts";
import { nodeIdParamSelector } from "./paramSelectors.ts";

export const rootNodeIdSelector = createSelector(
  nodeDesignsStateSelector,
  (state) => findParentlessNodeId(state) ?? null,
);

export const getDesignerNodeDataByIdSelector = createSelector(
  nodeDesignsStateSelector,
  (state): GetDesignerNodeDataById => getDesignerNodeDataByIdCreate(state),
);

export const rootNodeDesignerNodeDataOrNullSelector = createSelector(
  [getDesignerNodeDataByIdSelector, rootNodeIdSelector],
  (getDesignerNodeData, rootNodeId): DesignerNodeData | null => (rootNodeId ? getDesignerNodeData(rootNodeId) : null),
);

export const designerNodeDataSelectorCreate = (nodeId: number) =>
  createSelector(getDesignerNodeDataByIdSelector, (getDesignerNodeData) => getDesignerNodeData(nodeId));

export const designerNodeDataSelector = createSelector(
  [getDesignerNodeDataByIdSelector, nodeIdParamSelector],
  (getDesignerNodeData, nodeId): DesignerNodeData => getDesignerNodeData(nodeId),
);
